/* eslint-disable */
Date.prototype.format = function (demand) {
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(demand)) {
    demand = demand.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(demand)) {
      demand = demand.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return demand;
};

export default {
  formatDate(time, formatString) {
    const oldTime = time;
    if (time) {
      if (typeof time === "string") {
        time = Date.parse(time);
        if (!time) {
          if (Number(oldTime) && oldTime.length === 8) {
            time = oldTime;
            time = Date.parse(
              [time.slice(0, 4), time.slice(4, 6), time.slice(6, 8)].join("-")
            );
          } else {
            return oldTime;
          }
        }
      }
      formatString = formatString || "yyyy-MM-dd";
      return new Date(time).format(formatString);
    } else {
      return "";
    }
  },
  formatSize(num) {
    if (!num) {
      return "-";
    }
    if (num > 1024) {
      num = Math.floor(num / 1024);
      if (num > 1024) {
        num = Math.floor(num / 1024);
        if (num > 1024) {
          num = Math.round(num / 1024);
          return num + "G";
        }
        return num + "MB";
      }
      return num + "KB";
    }
    return num + "B";
  },
  getType: function (key) {
    return Object.prototype.toString
      .call(key)
      .replace("[object", "")
      .replace("]", "")
      .replace(/\s*/g, "");
  },
};

export const checkPhone = (phone) => {
  const reg =
    /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(18[0-9])|(17[0-9])|(19[0-9]))\d{8}$/;
  return reg.test(phone);
};
//加法
export function accAdd(arg1, arg2) {
  let r1, r2;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  const m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m).toFixed(2) / m;
}
